import React, { FC } from "react";
import { Button, List } from "antd";
import { NotificationRow } from "./notification-row";
import { Notification } from "../../data-types";
import styles from "./notification-list.css";
import { Reload } from "../reload";
import { LoadingSkeleton } from "../../../components/page-loading/skeleton/loading-skeleton";

const { buttons: buttonsClassName } = styles as any;

type Props = {
  notifications: Notification[];
  loading: boolean;
  onViewMatter: (id: number, isParent: boolean) => void;
  onDelete: (id: number) => void;
  onConfigureNotifications: () => void;
  onDeleteAll: () => void;
  onViewMessage: (id: number) => void;
  onReload: () => void;
};

export const NotificationList: FC<Props> = ({
  notifications,
  loading,
  onDelete,
  onViewMatter,
  onDeleteAll,
  onConfigureNotifications,
  onViewMessage,
  onReload,
}) => {
  return (
    <>
      <div className={buttonsClassName}>
        <Button size="small" style={{ borderRadius: "10px" }} onClick={onDeleteAll}>
          Delete All
        </Button>
        <Button size="small" style={{ borderRadius: "10px" }} onClick={onConfigureNotifications}>
          Configure Notifications
        </Button>
        <Reload loading={loading} delay={1000} onReload={onReload} />
      </div>
      {loading && <LoadingSkeleton count={3} loading={loading} active />}
      <List
        dataSource={notifications}
        renderItem={(item) => (
          <NotificationRow
            notification={item}
            onDelete={onDelete}
            onViewMatter={onViewMatter}
            onViewMessage={onViewMessage}
          />
        )}
      />
    </>
  );
};
